<!-- Modal modele info -->
<p-dialog [(visible)]="showDialog" autofocus="false" [modal]="true" [draggable]="false" [closable]="true" [style]="{ width: '90rem' }" (onHide)="onCancel()" (onShow)="onDialogShow()">
    <ng-template pTemplate="header">
        <div class="inline-flex align-items-center justify-content-center gap-2">
            <span class="font-bold" *ngIf="modelSelected">
                {{ 'HEADBAND.MODELE.MODAL.TITLE' | translate }} {{ modelSelected.libelle }}
            </span>
            <span>{{ ipsData.alt_Identifier ? '(' + ipsData.alt_Identifier + ')' : '' }}</span>
            <button [pTooltip]="tooltipContent" tooltipEvent="focus" tooltipPosition="bottom" class="info-button">i</button>
            <ng-template #tooltipContent>
                <div class="tooltip-content">
                    <span> {{ modelSelected.description }} </span>
                </div>
            </ng-template>
        </div>
    </ng-template>
    <div class="partenaire" *ngIf="partenaireTitle || partenaireImage">
        <img class="img-partenaire" src={{partenaireImage}} alt="Logo partenaire" *ngIf="partenaireImage">
        <span class="title-partenaire" *ngIf="partenaireTitle != ''" [innerHTML]="partenaireTitle"></span>
    </div>
    <div class="modal-container">
        <app-map-sensors [ipsData]="ipsData"></app-map-sensors>
        <app-modele-modal-graph-realtime [modelData]="modelRealTimeResult" [identifier]="ipsData.identifier"></app-modele-modal-graph-realtime>
        <app-modele-modal-graph-forecast 
        [modelDataForecast]="modelForecastResult" 
        [modelDataForecastLastest]="modelLastestForecastResult" 
        [modelDataObservation]="modelRealTimeResult"
        [modelSeuils]="modelSeuils"
        [identifier]="ipsData.identifier"
        [ipsPeriodesRetour]="ipsData.periodesRetour"
        [isUserPremiumOnModel]="isUserPremiumOnCurrentModel"></app-modele-modal-graph-forecast>
    </div>
</p-dialog>